import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Drawer from 'components/common/Drawer'
import ServiceBlock from '../ServiceBlock'
import ProductBlock from '../ProductBlock'
import Kit from '../Kit'
// TODO: Replace this with new QuoteSummary common component
import { PromotionsAndSummary } from 'src/components/ShoppingQuote'

const QuotedItem = ({
  className,
  freeAlignmentCheckSku,
  freeAlignmentCheckDisabled,
  quotedItemAndServices: {
    appliedPromotions,
    appointmentId,
    productPriceChangedQty,
    products = [],
    promoCode,
    quoteSummary,
    services
  } = {}
}) =>
  <Wrapper data-at-appointment-items className={ className } title="Quoted Items & Services">
    {
      Boolean(products && products.length) &&
      <ProductWrapper hasBorderBottom={ services && services.length }>
        {
          products.map((product, index) =>
            <ProductBlock
              key={ index }
              product={ product } />
          )
        }
        {
          !freeAlignmentCheckDisabled &&
          <FreeAligmentCheckWrapper>
            <Kit
              data-at-appointment-freealignmentcheck
              kit={ freeAlignmentCheckSku }
              success
              warning />
          </FreeAligmentCheckWrapper>
        }
      </ProductWrapper>
    }
    {
      services && services.map((service, index) =>
        <ServiceBlock
          key={ index }
          service={ service }
          freeAlignmentCheckSku={ freeAlignmentCheckSku } />
      )
    }
    {
      products && products.length > 0 &&
      <PromotionsAndSummary
        noEdit
        appliedPromotions={ appliedPromotions || [] }
        quoteSummary={ quoteSummary } />
    }
  </Wrapper>

QuotedItem.propTypes = {
  className: PropTypes.string,
  freeAlignmentCheckDisabled: PropTypes.bool,
  freeAlignmentCheckSku: PropTypes.shape(),
  quotedItemAndServices: PropTypes.shape()
}

export default QuotedItem

const Wrapper = styled(Drawer)`
  background-color: ${Theme.colors.off_white};
  border: none;
  ${Mixin.responsive('padding', '22px 20px', '16px 20px')}

  & [data-drawer-icon] {
    ${Media.mobile`
      top: 16px;
    `}
  }
`

const FreeAligmentCheckWrapper = styled.div`
  ${Mixin.responsive('margin-bottom', '30px', '20px')}
`

const ProductWrapper = styled.div`
  ${props => props.hasBorderBottom && css`
    border-bottom: 1px solid ${Theme.colors.light_grey};
  `}
`
